import { render, staticRenderFns } from "./DataView.vue?vue&type=template&id=7adb4b9a&"
import script from "./DataView.vue?vue&type=script&lang=js&"
export * from "./DataView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7adb4b9a')) {
      api.createRecord('7adb4b9a', component.options)
    } else {
      api.reload('7adb4b9a', component.options)
    }
    module.hot.accept("./DataView.vue?vue&type=template&id=7adb4b9a&", function () {
      api.rerender('7adb4b9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/DataView.vue"
export default component.exports